module.exports = __webpack_public_path__ + "static/media/CHALLENGER.28e55c4c.jpg";